import { Controller } from "@hotwired/stimulus";
import { useWindowResize } from "stimulus-use";

import { sm } from "../utils/viewportSizes";

export default class extends Controller {
  static targets = ["sidebar"];

  declare readonly hasSidebarTarget: boolean;
  declare readonly sidebarTarget: HTMLInputElement;

  connect() {
    useWindowResize(this);
    if (this.sidebarTarget.classList.contains("open")) {
      this.sidebarTarget.classList.remove("open");
    }
  }

  toggle() {
    if (this.sidebarTarget.classList.contains("menu-hidden")) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.element.classList.remove("menu-hidden");
    this.sidebarTarget.classList.remove("menu-hidden");
  }

  close() {
    this.element.classList.add("menu-hidden");
    this.sidebarTarget.classList.add("menu-hidden");
  }

  windowResize({ width }) {
    if (width < sm) {
      this.close();
    } else {
      this.open();
    }
  }
}
